import { PIECE_TYPES } from "@/game/pieces";
import { Tetromino } from "./Tetromino";

interface MarqueeProps {
  readonly phrases: readonly string[];
}

/**
 * The club's own shouting, kept as a printed tear-off strip.
 *
 * This is the one continuous animation on the site. It pauses on hover and
 * stops dead under `prefers-reduced-motion`, where it reads as a static band.
 */
export function Marquee({ phrases }: MarqueeProps) {
  const run = [...phrases, ...phrases];

  return (
    <div className="group relative overflow-hidden border-y-2 border-ink bg-ink py-3">
      <div
        className="flex w-max animate-[marquee_38s_linear_infinite] items-center gap-8
          group-hover:[animation-play-state:paused]
          motion-reduce:animate-none"
      >
        {run.map((phrase, index) => (
          <span key={`${phrase}-${index}`} className="flex shrink-0 items-center gap-8">
            <span className="display whitespace-nowrap text-lg text-field sm:text-xl">
              {phrase}
            </span>
            <Tetromino type={PIECE_TYPES[index % PIECE_TYPES.length]!} cell={7} />
          </span>
        ))}
      </div>
    </div>
  );
}
